import Link from 'gatsby-link'
import * as React from 'react'
import humanize from '../tinyhumantime'

interface IBlogPostProps {
  className?: string

  post: {
    id: string
    frontmatter: {
      date: string
      path: string
      title: string
      author: string
    }
    html: string
  }
}

const BlogPost = (props: IBlogPostProps) => {
  const { post } = props

  const date = humanize(new Date(post.frontmatter.date), new Date()) + ' ago'

  return (
    <article key={post.id} className={`blog__post blog__list__item ${props.className}`}>
      <h3
        className="blog__post__date"
        data-tip={`Posted on ${post.frontmatter.date}.`}
      >
        {date}
      </h3>
      <h1 className="blog__post__title">
        <Link to={post.frontmatter.path}>
          <span dangerouslySetInnerHTML={{ __html: post.frontmatter.title }} />
        </Link>
      </h1>
      <div
        className="blog__post__content"
        dangerouslySetInnerHTML={{ __html: post.html }}
      />
      <p className="blog__post__byline">From {post.frontmatter.author}</p>
    </article>
  )
}

export default BlogPost


// WEBPACK FOOTER //
// ./src/components/BlogPost.tsx